import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Link,
  Box,
  CircularProgress,
  Tooltip,
  IconButton,
  Pagination,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { MdModeEditOutline, MdOutlineRemoveRedEye } from "react-icons/md";
import axios from "axios";
import ApiConfig from "../../Auth/ApiConfig";
import { TbPasswordUser } from "react-icons/tb";
import { IoEyeSharp } from "react-icons/io5";
import PlansCard from "../../Common/DashboardCards/PlansCard";
import { AuthContext } from "../../Auth/context/Auth";

export default function Payment() {
  const location = useLocation();
  const isAdminPayment = location.pathname === "/payments";
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState("");
  console.log("ASfadsfgads", totalPages);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const auth = useContext(AuthContext);
  const userData = auth.userData;

  useEffect(() => {
    getPlansHanlder();
  }, [page, limit, searchQuery]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const getPlansHanlder = async () => {
    const token = window.localStorage.getItem("adminToken");
    setLoading(true);

    try {
      const response = await axios({
        method: "GET",
        url: ApiConfig.getallpayments,
        headers: {
          authorization: `Bearer ${token}`,
        },
        params: {
          page: page,
          limit: limit,
          q: searchQuery,
        },
      });
      console.log("successsuccess", response?.data?.success);
      if (response?.data?.success === true) {
        setLoading(false);

        console.log("654654456", response?.data?.data[0]?.rows);
        setPlans(
          response?.data?.data[0]?.rows?.filter(
            (item) => item?.status === "complete"
          )
        );
        setTotalPages(response?.data?.data?.[0]?.count);
      }
    } catch (error) {
      setLoading(false);

      console.log("errorerror", error);
      return error?.response;
    }
  };
  const handleSearchQueryChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
      {["admin", "insurance"].includes(userData?.role) && <PlansCard />}
      <Box
        sx={{
          height: "100vh",
          background: "#F5F5F5",
          marginTop: { xs: "0px", md: "3rem" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontSize: "30px", fontWeight: "700", fontFamily: "rubik" }}
          >
            Payment List
          </Typography>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            type="search"
            value={searchQuery}
            onChange={handleSearchQueryChange}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              marginTop: {
                xs: "10px",
                md: "0px",
              },
              minWidth: 200,
              "& .MuiOutlinedInput-root": {
                paddingRight: 0,
                padding: "2.5px 0px",
                borderRadius: "10px",
              },
            }}
            InputProps={{
              sx: { paddingRight: "8px" },
            }}
          />
        </Box>
        <TableContainer
          component={Paper}
          elevation={3}
          sx={{
            height: "auto",
            background: "#fff",
            borderRadius: "10px",
            marginTop: "20px",
            width: { xs: "100% !important", md: "100% !important" },
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {[
                  // "Serial Number",
                  "Transaction Id	",
                  "Policy Holder	",
                  "Purchase",
                  "Policy Id",
                  "Method",
                  "Status",
                  "Amount",
                ].map((heading, i) => (
                  <TableCell key={i} sx={{ fontWeight: "bold" }}>
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    sx={{ borderBottom: "none" }}
                  >
                    <Box sx={{ py: 4, marginLeft: "10rem" }}>
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : plans?.length > 0 ? (
                plans?.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                      borderRadius: "10px",
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    {/* <TableCell sx={{ padding: "25px" }}>{index + 1}</TableCell> */}
                    <TableCell>
                      {row.transaction_id} {row?.reference_id}
                    </TableCell>
                    <TableCell>{row.full_name}</TableCell>
                    <TableCell>{row.payment_for}</TableCell>
                    <TableCell>{row.policy_id}</TableCell>
                    <TableCell>{row.method}</TableCell>
                    <TableCell>{row.status}</TableCell>
                    <TableCell>
                      {row.amount} {row?.currency}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} sx={{ height: "100px", p: 0 }}>
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="textSecondary"
                        sx={{ fontSize: "15px !important" }}
                      >
                        No Data Found
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPages > 1 && plans?.[0]?.rows?.length > 0 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              // marginTop: "10px",
              paddingTop: "20px",
              "& .Mui-selected": {
                backgroundColor: "#00b2ff !important",
                color: "#fff !important",
                borderRadius: "5px",
              },
              "& .MuiPaginationItem-root": { color: "black" },
            }}
          >
            <Pagination
              page={page}
              onChange={handlePageChange}
              count={totalPages}
            />
          </Box>
        )}
      </Box>
    </>
  );
}
